import { getImageStudioPackage } from './image-studio-opener-loader.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
async function setupImageEditor(imageEditorWixSettings, rootElementId, fileName, onSave, onClose) {
  const { MediaImageStudio, MediaImageStudioEvents, MediaImageStudioMode } = await getImageStudioPackage();
  const resolvedImageEditorWixSettings = await imageEditorWixSettings;
  const mediaImageStudio = new MediaImageStudio(__spreadProps(__spreadValues({}, resolvedImageEditorWixSettings), {
    metasiteId: resolvedImageEditorWixSettings.metaSiteId,
    appendTo: document.querySelector(`[id=${rootElementId}]`)
  }));
  const imageDataSubscription = mediaImageStudio.once(
    MediaImageStudioEvents.ImageData,
    (imageData) => {
      const file = blobToFile(imageData, fileName);
      onSave(file);
    }
  );
  mediaImageStudio.once(MediaImageStudioEvents.Close, () => {
    imageDataSubscription.remove();
    mediaImageStudio.kill();
    onClose();
  });
  mediaImageStudio.show({
    mode: MediaImageStudioMode.Transform,
    fileId: fileName
  });
}
function blobToFile(blob, fileName) {
  blob.lastModified = (/* @__PURE__ */ new Date()).getTime();
  blob.name = fileName;
  blob.webkitRelativePath = "";
  return blob;
}

export { setupImageEditor };
//# sourceMappingURL=image-editor-logic.js.map
